import { useMutation, useQuery } from '@apollo/client';
import React, { Fragment, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import CustomLoader from 'src/components/CustomLoader/CustomLoader';
import { useAuth } from 'src/hooks/auth';

import Error from './components/Error/Error';
import EXPIRED_AD_RENEW from './queries/expiredAdRenew';
import USER_DETAILS from './queries/userDetails';

// Todo: codegen to get response types for all our queries
interface User {
  user: {
    firstName: string;
    lastName: string;
    emailAddress: string;
  };
}

const RenewListing = () => {
  const {
    data,
    loading: queryLoading,
    error: queryError,
  } = useQuery<User>(USER_DETAILS);
  const [
    postExpiredAdEmail,
    { error: mutationError, called, loading: mutationLoading },
  ] = useMutation(EXPIRED_AD_RENEW);

  const { getAuthToken } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const token = getAuthToken();
    if (Boolean(token) && data && !queryLoading && !called) {
      postExpiredAdEmail({
        variables: {
          input: {
            emailAddress: data.user.emailAddress,
            firstName: data.user.firstName,
            lastName: data.user.lastName,
          },
        },
      });
    }
    if (called && !mutationLoading && !mutationError) {
      navigate('/sell/renew-listing/success');
    }
  });

  return (
    <Fragment>
      {(queryLoading || mutationLoading || !called) && !queryError && (
        <CustomLoader />
      )}
      {(queryError || mutationError) && <Error />}
    </Fragment>
  );
};

export default RenewListing;
